import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { combineLatest, forkJoin, Observable, of } from "rxjs";
import {
  catchError,
  mergeMap,
  switchMap,
  switchMapTo,
  tap,
} from "rxjs/operators";
import { PriceService } from "src/app/dashboard/price/price.service";
import { UserService } from "src/service/user.service";
import { AuthService } from "../auth/auth.service";
import { JwtObj } from "../auth/jwt-obj";
import { User } from "../model/user/user";
import { CartService } from "./cart/cart.service";
import { NotificationService } from "./notifications/notification.service";
import { WalletService } from "./wallet/wallet.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService implements Resolve<any> {
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private priceService: PriceService,
    private walletService: WalletService,
    private cartService: CartService,
    private notificationService: NotificationService
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): User | Observable<any> | Promise<any> {
    if (this.authService.isLoggedIn) {
      const jwtObj: JwtObj = this.authService.fetchJwt();
      return this.userService.isExist(jwtObj.uid).pipe(
        switchMap((isExist) => {
          if (isExist) {
            //   this.notificationService.requestPermission()
            return this.userService.getUser().pipe(
              switchMap(() => this.priceService.fetchPriceList()),
              switchMap(() => this.walletService.syncWalletBalance()),
              switchMap(() => this.cartService.syncCart())
            );
          } else {
            return of(true);
          }
        })
      );
    }
    return of(true);
  }
}

